module.exports = __webpack_public_path__ + "assets/static/media/splash_screen_5.bf676f3a.png";